import { createEpsScopedClient } from './eps-scoped-client'

// Shares eps.client's config and auth interceptor, so a plain `yarn dev` stays on dev EPS
// and only `yarn dev:local` (IS_LOCAL_DEV=true) points at localhost:3010.
export const annualBenefitPlanningApi = createEpsScopedClient(
  '/api/v1/annual-benefit-planning'
)

export default annualBenefitPlanningApi
